import React from 'react';
import Money from '../../../components/Money';

var ActiveLimit = function ActiveLimit(_ref) {
  var amount = _ref.amount,
      currency = _ref.currency,
      period = _ref.period;
  return React.createElement(
    'div',
    { className: 'limit-info-container' },
    amount && React.createElement(
      'div',
      { className: 'active-limit-content signup', key: Math.random() },
      React.createElement(
        'div',
        { className: 'limit-name' },
        period
      ),
      React.createElement(
        'div',
        { className: 'active-limit-amount' },
        React.createElement(Money, { decimals: false, value: amount, currency: currency })
      )
    )
  );
};

export { ActiveLimit };